export default __webpack_public_path__ + "static/media/lk.dcc8ece6.svg";